import Information from "./Information"
import { cn } from "../lib/utils"

const ErrorAlert = ({ title, message, onDismiss, className }) => {
  return (
    <div className={cn("relative", className)}>
      <Information variant="error" title={title} description={message} />
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="absolute right-2 top-2 text-red-500 hover:text-red-700 transition-colors"
          aria-label="Dismiss error"
        >
          <i className="fa-solid fa-xmark text-xl"></i>
        </button>
      )}
    </div>
  )
}

export default ErrorAlert
